<script>
  export let type = 'button'
  export let size = null
  export let color = null
  export let disabled = false
</script>

<style>
  button {
    /*font: inherit;*/
    text-transform: uppercase;
    font-size: 1.5rem;
    border: 1px solid var(--blue);
    background: var(--blue);
    padding: .8rem 1.2rem;
    color: white;
    border-radius: var(--radius);
    cursor: pointer;
    text-decoration: none;
  }

  button:focus {
    outline: none;
  }

  button:hover,
  button:active {
    background: var(--light-blue);
    border-color: var(--light-blue);
  }

  button:disabled,
  button:disabled:hover,
  button:disabled:active {
    background: #ccc;
    border-color: #ccc;
    color: #959595;
    box-shadow: none;
    cursor: not-allowed;
  }

  .success {
    background: var(--green);
    border-color: var(--green);
  }

  .success:hover,
  .success:active {
    background: #31B51D;
    border-color: #31B51D;
  }

  .error {
    background: var(--red);
    border-color: var(--red);
  }

  .cancel {
    background: var(--greylight);
    border-color: var(--greylight);
  }

  .error:hover,
  .error:active,
  .cancel:hover,
  .cancel:active {
    background: #E33E22;
    border-color: #E33E22;
  }

  .full {
    width: 100%;
    padding: 1.2rem;
    margin-top: .5rem;
  }

</style>

<button class='{size} {color}' type={type} {disabled} on:click><slot /></button>
